import { clearAdminSession, getAdminToken } from "./adminAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  "http://secondbite-manage.localhost/admin-api/v1"
).replace(/\/+$/, "");

const params = (filters = {}) => {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) query.set(key, value);
  });
  return query;
};

const authorizedFetch = async (url, accept = "application/json") => {
  const response = await fetch(url, {
    headers: { Accept: accept, Authorization: `Bearer ${getAdminToken()}` },
  });
  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }
  return response;
};

export const getAdminReports = async (filters) => {
  let response;
  try {
    response = await authorizedFetch(`${API_BASE_URL}/reports?${params(filters)}`);
  } catch (error) {
    if (error.message === "Your session has expired.") throw error;
    throw new Error("Unable to connect to the SecondBite backend.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to load reports.");
  return payload.data;
};

export const exportAdminReport = async (filters) => {
  const response = await authorizedFetch(
    `${API_BASE_URL}/reports/export?${params(filters)}`,
    "text/csv",
  );
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.message || "Unable to export report.");
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `secondbite-report-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
